export class ThrottledLogger<Key> {
	private onLog: (key: Key, count: number) => void;
	private throttleCutoff: number;
	private throttles: Map<Key, { counter: number; timer: number }> = new Map();

	public constructor(
		onLog: (key: Key, count: number) => void,
		throttleCutoff = 15_000,
	) {
		this.onLog = onLog;
		this.throttleCutoff = throttleCutoff;
	}

	public log(key: Key): void {
		const val = this.throttles.get(key);
		if (val == null) {
			this.onLog(key, 1);
			this.throttles.set(key, {
				counter: 0,
				timer: window.setTimeout(() => {
					const val = this.throttles.get(key);
					if (val == null) return;
					this.throttles.delete(key);

					if (val.counter > 0) {
						this.onLog(key, val.counter);
					}
				}, this.throttleCutoff),
			});
		} else {
			val.counter++;
		}
	}

	public flush(key: Key): void {
		const val = this.throttles.get(key);
		if (val == null) return;
		this.throttles.delete(key);

		clearTimeout(val.timer);

		if (val.counter > 0) {
			this.onLog(key, val.counter);
		}
	}
}
